import { useEffect } from "react";

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function useScrollReveal(
  selector = ".reveal-on-scroll",
  options = {},
  dependencies = []
) {
  const {
    triggerRatio = 0.12,
    once = true,
    visibleClass = "is-visible",
    root = null,
    rootMargin = "0px 0px -8% 0px",
  } = options;

  useEffect(() => {
    if (!isBrowser()) return;

    const elements = Array.from(document.querySelectorAll(selector));

    if (!elements.length) return;

    const showAllElements = () => {
      elements.forEach((element) => {
        element.classList.add(visibleClass);
      });
    };

    if (!("IntersectionObserver" in window)) {
      showAllElements();
      return;
    }

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      showAllElements();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target;

          if (entry.isIntersecting) {
            element.classList.add(visibleClass);

            if (once) {
              observer.unobserve(element);
            }
          }
        });
      },
      {
        root,
        rootMargin,
        threshold: triggerRatio,
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, [
    selector,
    triggerRatio,
    once,
    visibleClass,
    root,
    rootMargin,
    ...dependencies,
  ]);
}